import { useMutation } from "react-query";
import axiosInstance from "../../Services/axiosConfig";
import paths from "../paths";

const fetchAssetsByName = async (searchTerm) => {
  const response = await axiosInstance.post(paths.getAssetName(), {
    offset: 0,
    limit: 100,
  });

  const allAssets = response?.data?.data || [];

  if (!searchTerm || searchTerm.length < 3) return [];

  return allAssets.filter((item) =>
    item.name?.toLowerCase().startsWith(searchTerm.toLowerCase())
  );
};

export const useAssetNameSearch = () =>
  useMutation((searchTerm) => fetchAssetsByName(searchTerm));
